import { render } from "./lIsDeleted.vue?vue&type=template&id=a1770034"
import script from "./lIsDeleted.vue?vue&type=script&lang=js"
export * from "./lIsDeleted.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__